<template>
<div>
    <base-textarea v-model="events" :placeholder="$t('observations-ph')" :rows=3 :maxRows=9 :readOnly="historyReadOnly"></base-textarea>
    <base-button v-if="!historyReadOnly" @click="saveEvents">{{ $t('save') }}</base-button>
</div>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard.vue'
import BaseButton from '@/components/base/buttons/BaseButton'
import BaseTextarea from '@/components/base/forms/BaseTextarea'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    components: {
        BaseCard,
        BaseButton,
        BaseTextarea
    },
    props: {
        title: String
    },
    mixins: [clinicHistoryMixin, i18nMixin(I18N_FILE)],
    created () {
        ClinicHistoryRepository().getEvents(this.events).then((response) => {
            if (response.data.data) {
                this.events = response.data.data
            }
        })
    },
    data () {
        return {
            events: null
        }
    },
    methods: {
        saveEvents () {
            let data = {value: this.events}
            ClinicHistoryRepository().saveEvents(data).then((response) => {
                if (response.data.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryEventsSection.vue